import styled from 'styled-components';
export const TableWrapper = styled.div `
  border-top: 1px solid var(--blue--light);
  padding: 1.5rem;
`;
